import * as React from "react";
import { Box, Radio, Typography, Grid,FormControlLabel } from "@mui/material";

export default function Selection({ question, onAnswer = () => {} }) {
    const [answer, setAnswer] = React.useState("");

	React.useEffect(() => {
		// reset proceed button
		setAnswer([]);
	}, [question]);

	const handleSetAnswer = (e) => {
		setAnswer(e.target.value);

		const canProceed = e.target.value !== ''
       
		onAnswer({
			canProceed,
			answer: e.target.value,
		});
	};

	return (
		<React.Fragment>
			<Box className="choices-container" sx={{ px: { xs: 4, sm: 8 } }}>
				<Grid container alignItems="center" sx={{ my: 2 }}>
					{question.questionList.map((data, i) => (
						<Grid
							item
							xs={12}
							sx={{ display: "flex", alignItems: "center" }}
							key={`radio-selection-${i}-${Math.random()}`}
						>
							<Box
								className="dot-filled"
								sx={{ maxWidth: "90%" }}
							>
								
                                <FormControlLabel
							key={`selection-${i}-${Math.random()}`}
							control={
								<Radio
                                name="radio-selection"
                                id={`rd-${i}`}
                                defaultChecked={answer === data[0]}
                                value={data[0]}
									onChange={handleSetAnswer}
								/>
							}
							label={data[0]}
						/>
							</Box>
							<Typography
								htmlFor={`rd-${i}`}
								sx={{
									textAlign: "left",
									bgcolor: "#deece8",
									pl: 1,
								}}
							>
								{data[1]}
							</Typography>
						</Grid>
					))}
				</Grid>
			</Box>
		</React.Fragment>
	);
}
